import { ActionTypes } from "../actions/types";
import {
    FILE_UPLOAD_STARTED,
    FILE_UPLOAD_PROGRESS,
    FILE_UPLOAD_COMPLETED,
    FILE_UPLOAD_FAILED,
    FILE_UPLOAD_CLEARED,
} from "../actions";
import { FilesState } from "../../models/states/FilesState";

const INITIAL_STATE: FilesState = {
    filesByVariableName: {},
};

export const filesReducer = (state = INITIAL_STATE, action: ActionTypes): FilesState => {
    switch (action.type) {
        case FILE_UPLOAD_STARTED: {
            const { variableName, matrix, fileName, size, cancellationTokenSource } = action;
            const file = (state.filesByVariableName[variableName] || []).find(
                (f) => f.matrix === matrix,
            );
            if (file) {
                file.cancellationTokenSource.cancel();
            }
            return {
                ...state,
                filesByVariableName: {
                    ...state.filesByVariableName,
                    [variableName]: [
                        ...(state.filesByVariableName[variableName] || []).filter(
                            (f) => f.matrix !== matrix,
                        ),
                        {
                            matrix,
                            fileName,
                            size,
                            cancellationTokenSource,
                            status: "started",
                            progress: 0,
                        },
                    ],
                },
            };
        }
        case FILE_UPLOAD_CLEARED: {
            const { variableName, matrix } = action;
            const file = (state.filesByVariableName[variableName] || []).find(
                (f) => f.matrix === matrix,
            );
            if (file) {
                file.cancellationTokenSource.cancel();
            }
            return {
                ...state,
                filesByVariableName: {
                    ...state.filesByVariableName,
                    [variableName]: [
                        ...(state.filesByVariableName[variableName] || []).filter(
                            (f) => f.matrix !== matrix,
                        ),
                    ],
                },
            };
        }
        case FILE_UPLOAD_PROGRESS: {
            const { variableName, matrix, progress } = action;
            const file = (state.filesByVariableName[variableName] || []).find(
                (f) => f.matrix === matrix,
            );
            return {
                ...state,
                filesByVariableName: {
                    ...state.filesByVariableName,
                    [variableName]: [
                        ...(state.filesByVariableName[variableName] || []).filter(
                            (f) => f.matrix !== matrix,
                        ),
                        { ...file, status: "ongoing", progress },
                    ],
                },
            };
        }
        case FILE_UPLOAD_COMPLETED: {
            const { variableName, matrix } = action;
            const file = (state.filesByVariableName[variableName] || []).find(
                (f) => f.matrix === matrix,
            );
            return {
                ...state,
                filesByVariableName: {
                    ...state.filesByVariableName,
                    [variableName]: [
                        ...(state.filesByVariableName[variableName] || []).filter(
                            (f) => f.matrix !== matrix,
                        ),
                        { ...file, status: "completed", progress: 1 },
                    ],
                },
            };
        }
        case FILE_UPLOAD_FAILED: {
            const { variableName, matrix } = action;
            const file = (state.filesByVariableName[variableName] || []).find(
                (f) => f.matrix === matrix,
            );
            return {
                ...state,
                filesByVariableName: {
                    ...state.filesByVariableName,
                    [variableName]: [
                        ...(state.filesByVariableName[variableName] || []).filter(
                            (f) => f.matrix !== matrix,
                        ),
                        { ...file, status: "failed" },
                    ],
                },
            };
        }
        default:
            return state;
    }
};
